import { reportError } from '../lib/bugsnag'

export function assertUnreachable(_value: never): void {
  const error = new Error('Statement should be unreachable')

  reportError(error)
}
